import { RedesignRating } from '@app/services/hooks/feedbackSurvey/useFeedbackSurvey';
import { useTranslation } from 'react-i18next';

import { Button } from '../various/Button';
import { Happy, Loader, Meh, Sad } from '../various/Icons';

interface Props {
  onRatingSelect: (rating: RedesignRating) => void;
  onCancel: VoidFunction;
  isLoading?: boolean;
}

export const SurveyRating = ({ onRatingSelect, onCancel, isLoading = false }: Props) => {
  const { t } = useTranslation(['common', 'onboarding']);
  const ratingOptions = [
    {
      icon: Sad,
      value: 'sad',
    },
    {
      icon: Meh,
      value: 'meh',
    },
    {
      icon: Happy,
      value: 'happy',
    },
  ] as const;

  if (isLoading) {
    return (
      <div className="flex justify-center text-neutral-40">
        <Loader className="size-10 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="mb-6 flex justify-center gap-10">
        {ratingOptions.map(ratingOption => (
          <Button
            key={ratingOption.value}
            color="secondary"
            variant="ghost"
            icon={ratingOption.icon}
            iconClassName="size-12"
            onClick={() => {
              onRatingSelect(ratingOption.value);
            }}
          />
        ))}
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="bordered" color="secondary" onClick={onCancel}>
          {t('common:close')}
        </Button>
      </div>
    </div>
  );
};
